import { ElementType, parseDocument } from "htmlparser2";

type ChildNode = ReturnType<typeof parseDocument>["childNodes"][number];

const resolvedPhrases = ["resolved", "completed", "scheduled"];

export function isIncidentResolved(description?: string): boolean {
  if (!description) {
    return false;
  }

  const doc = parseDocument(description);

  return traverseUntilTrue(
    doc,
    (node) =>
      node.type === ElementType.Text &&
      resolvedPhrases.includes(node.data.toLowerCase())
  );
}

function traverseUntilTrue(
  node: ChildNode,
  condition: (node: ChildNode) => boolean
): boolean {
  if (condition(node)) {
    return true;
  }

  if ("childNodes" in node) {
    return node.childNodes.some((_node) => traverseUntilTrue(_node, condition));
  }

  return false;
}
